import { useRecoilValue } from "recoil";
import { chatUserAtom } from "../../shared/chatUser";
import Typography from "../Typography/Typography";
import { ChatHeaderStyle } from "./ChatHeaderStyle";
import ReferChatModal from "../Dialog/ReferChatModal";
import { VscReferences } from "react-icons/vsc";
import Button from "../Button/Button";
import { useState } from "react";
export const ChatHeader = ({
  data,
  chatlist,
  refer,
  idStartChat,
  supplier,
}) => {
  const chatUser = useRecoilValue(chatUserAtom);

  const [show, setShow] = useState(false);
  const chatUserGenerator = () => {
    if (chatUser) {
      return chatUser?.props?.children[1].props?.children[0]?.props?.children[0]
        ?.props?.children === "پشتیبان"
        ? "پشتیبان"
        : chatUser?.props?.children[1].props?.children[0]?.props?.children[0]
            ?.props?.children;
    }
  };

  return (
    <ChatHeaderStyle>
      <div className="col-12 d-flex justify-content-between">
        <Typography className="name d-flex align-items-center">
          {chatlist ? "لیست چت ها" : chatUser ? chatUserGenerator() : data}
        </Typography>
        {/* <Typography className="status">
          <BsDot size="30px" /> فعال
        </Typography> */}
        {!supplier ? (
          <div className="refer">
            <Button
              onclick={() => setShow(true)}
              bgColor="#009ef7"
              color="#fff"
              small="fit-content"
            >
              <VscReferences />
            </Button>
          </div>
        ) : null}
      </div>
      <ReferChatModal
        refer={refer}
        idStartChat={idStartChat}
        handleClose={() => setShow(false)}
        show={show}
      />
    </ChatHeaderStyle>
  );
};
